var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.6001L3.10192 11.761C4.19545 10.8042 5.84356 10.8591 6.87101 11.8865L12.0187 17.0342C12.8433 17.8589 14.1415 17.9714 15.0957 17.3007L15.4536 17.0493C16.8266 16.0842 18.6844 16.1961 19.9319 17.3188L23.8001 20.8001",
    stroke: "#6AA13C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8745 2.12237L21.375 1.62184C22.2043 0.792556 23.5488 0.792556 24.3781 1.62184C25.2075 2.45113 25.2075 3.79566 24.3781 4.62494L23.8776 5.12546M20.8745 2.12237C20.8745 2.12237 20.9371 3.18595 21.8755 4.12443C22.8141 5.06289 23.8776 5.12546 23.8776 5.12546M20.8745 2.12237L16.2731 6.72384C15.9613 7.03552 15.8055 7.19135 15.6715 7.36318C15.5135 7.56586 15.3779 7.78518 15.2673 8.01722C15.1735 8.21394 15.1039 8.423 14.9645 8.84116L14.5182 10.1799M23.8776 5.12546L19.2761 9.72695C18.9644 10.0386 18.8087 10.1945 18.6368 10.3285C18.4342 10.4866 18.2148 10.6221 17.9827 10.7326C17.786 10.8265 17.577 10.8961 17.1588 11.0355L15.8201 11.4818M14.5182 10.1799L14.2295 11.0462C14.1608 11.2519 14.2145 11.4788 14.3678 11.6322C14.5212 11.7855 14.7481 11.8392 14.9538 11.7705L15.8201 11.4818M14.5182 10.1799L15.8201 11.4818",
    stroke: "#6AA13C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 13.0001C25.0001 18.6569 25.0001 21.4854 23.2427 23.2427C21.4854 25.0001 18.6569 25.0001 13.0001 25.0001C7.34317 25.0001 4.51473 25.0001 2.75737 23.2427C1 21.4854 1 18.6569 1 13.0001C1 11.6461 1 10.4541 1.0241 9.40004M13.0001 1C7.34317 1 4.51473 1 2.75737 2.75737C2.24759 3.26716 1.88568 3.86706 1.62875 4.60002",
    stroke: "#6AA13C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerMenuIcon);
export default __webpack_public_path__ + "static/media/banner-menu-icon.96e43976db91742c169908cab8fb72cc.svg";
export { ForwardRef as ReactComponent };